import React from 'react';

/**
 * Wordmark de Vatuco escrito como texto: "VAT" en el color principal del
 * contexto y "UCO" en color de acento. Sizing por className (text-xl, etc.).
 *
 * Props:
 *  - className: clases del wrapper (típicamente font-size + responsive).
 *  - primary:   color de "VAT". Default 'currentColor' (hereda del padre).
 *  - accent:    color de "UCO". Default token primary del theme.
 */
export default function VatucoLogo({ className = '', primary, accent }) {
  return (
    <span
      className={`font-black tracking-tight whitespace-nowrap select-none ${className}`.trim()}
      style={primary ? { color: primary } : undefined}
    >
      VAT
      <span style={{ color: accent || 'var(--md-sys-color-primary, #2563eb)' }}>
        UCO
      </span>
    </span>
  );
}
